"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beltColor = void 0;
exports.beltColor = {
    white: '#D6D6D6',
    red: '#FF4141',
    orange: '#FFA439',
    green: '#33DB7A',
    black: '#000000',
    golden: '#FFCE00'
};
